function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { htmlSafe, isHTMLSafe } from '@ember/template';
import Formatter from './-base';
const escaped = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};
const needToEscape = /[&<>"'`=]/;
const badCharacters = /[&<>"'`=]/g;

// https://github.com/emberjs/ember.js/blob/v5.6.0/packages/%40ember/-internals/glimmer/lib/utils/string.ts#L103-L118
function escapeExpression(value) {
  if (!needToEscape.test(value)) {
    return value;
  }
  return value.replace(badCharacters, character => {
    return escaped[character];
  });
}
function escapeOptions(object) {
  if (typeof object !== 'object') {
    return;
  }
  const escapedOpts = {};
  Object.keys(object).forEach(key => {
    const value = object[key];
    if (isHTMLSafe(value)) {
      // If the option is an instance of Ember SafeString,
      // we don't want to pass it into the formatter, since the
      // formatter won't know what to do with it. Instead, we cast
      // the SafeString to a regular string using `toHTML`.
      // Since it was already marked as safe we should *not* escape it.
      // @ts-ignore: see comment above
      escapedOpts[key] = value.toHTML();
    } else if (typeof value === 'string') {
      // @ts-ignore: see comment above
      escapedOpts[key] = escapeExpression(value);
    } else {
      // @ts-ignore: see comment above
      escapedOpts[key] = value; // copy as-is
    }
  });
  return escapedOpts;
}
/**
 * @private
 * @hide
 */
export default class FormatMessage extends Formatter {
  // ! Function overloads are not passed through generic types for reasons that
  // evade my knowledge. ¯\_(ツ)_/¯
  // For this reason these types need to be manually copied over to the
  // `IntlService#formatMessage`.

  format(intl, stringOrDesc, options) {
    const isHTMLSafe = options && options.htmlSafe;
    const escapedOptions = isHTMLSafe ? escapeOptions(options) : options;
    const desc = stringOrDesc && typeof stringOrDesc === 'object' ? stringOrDesc : {
      id: stringOrDesc,
      defaultMessage: stringOrDesc
    };
    const result = intl.formatMessage(desc, escapedOptions, {
      ignoreTag: true
    });
    return isHTMLSafe ? htmlSafe(result) : result;
  }
}
_defineProperty(FormatMessage, "type", 'message');